
import {
  RoomSelectPicker,
} from "components/js_selectpicker/room_selectpicker"
import {
  InputSelector as BaseInputSelector,
  Selector as BaseSelector,
} from "components/js_selectpicker/base"


type Selector = BaseSelector & {
  container: string
}

type InputSelector = BaseInputSelector & {
  container?: string
}

const default_selector = {
  scope:        ".cell-real-estate-mortgages-calculator_loan-term--container",
  main:         ".cell-real-estate-mortgages-calculator_loan-term",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
  container:    ".select2-container",
}


export class LoanTermSelector extends RoomSelectPicker {
  protected selector: Selector

  protected $container: JQuery

  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, default_selector, selector)

    super(merged_selector)

    if (this.$scope.length === 0){
      throw new Error("this.$scope absent")
    }

    this.selector = merged_selector

    this.$container = this.$scope.find(this.selector.container)
  }
}


const Factory = {
  create(selector?: InputSelector){
    return new LoanTermSelector(selector)
  },
}

export {
  Factory,
}
